import { type CreditCardNetwork } from '@wix/cashier-common/dist/src/enums/payments/CreditCardNetwork';
import { publicRoutes } from '../../../constants/appRoutes';
import { Port } from '../../../../dev/Port';

export const getCardNetworkIconURL = (cardNetwork: CreditCardNetwork): string => {
  return window.__IS_RC_OVERRIDE__
    ? `${window.__STATICS_BASE_URL__}assets/cardNetworks/${cardNetwork}.svg`
    : process.env.NODE_ENV !== 'production'
    ? `http://localhost:${Port.CDN}/assets/cardNetworks/${cardNetwork}.svg`
    : `${publicRoutes.cardNetworks}/${cardNetwork}.svg`;
};
